import { AccountingEntryNumberModeEnum } from '~modules/connectors/modules/load/common/services/accounting-number-mode.service';
import { LetteringScopeEnum } from '~modules/connectors/modules/load/common/services/lettering-scope.service';
import { FileDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

export const acdZipFecDownLoadFieldsConfiguration : FileDownloadFieldsConfiguration = {
    toolLabel: 'acd_zip_fec_dl',
    generatePartialLettering: {
        defaultValue: false,
        visible: false
    },
    accountingEntryNumberMode: {
        defaultValue: AccountingEntryNumberModeEnum.PER_JOURNAL
    },
    removeSpecialCharacters: {
        visible: true,
        defaultValue: false
    },
    letteringScope: {
        defaultValue: LetteringScopeEnum.BY_ACCOUNT,
        visible: false
    }
}